// @flow
import hello from 'hellojs';
import Cookies from 'js-cookie';
import queryString from 'query-string';

import hosts from '../config/api.json';

let credentials = Cookies.get('credentials') ? JSON.parse(Cookies.get('credentials')) : {};

const scopes = [
  'https://www.googleapis.com/auth/plus.login',
  'https://www.googleapis.com/auth/calendar',
  'profile',
  'email',
];

hello.init({
  google: '568052108735-d9p8otk5kdlb262sbotp8g60n7c7qi9u.apps.googleusercontent.com',
}, {
  response_type: 'code',
  redirect_uri: '/',
  scope: scopes.join(', '),
});

const onAuthResponse = async (data: Object) => {
  const apiHost = hosts[process.env.NODE_ENV || 'development'];
  const res = await fetch(`${apiHost.host}/auth/token`, {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    body: JSON.stringify(data),
  });
  credentials = await res.json();

  if (credentials.access !== undefined) {
    Cookies.set('credentials', credentials);
    window.location.href = `/#/${credentials.access}`;
    window.console.log(credentials);
  }
};

const login = () => {
  Cookies.set('credentials', {});
  hello('google').login({
    display: 'none',
    scope: scopes.join(', '),
    callback: onAuthResponse,
  });
};

const logout = () => {
  hello('google').logout();
  credentials = {};
  Cookies.remove('credentials');
  window.location.href = '/#';
};

const getCurrentUser = () => ({ mail: credentials.key, type: credentials.access });
const isLoggedIn = () => Cookies.get('credentials');

const request = (data: Object) => {
  const apiHost = hosts[process.env.NODE_ENV || 'development'];
  const settings = {
    headers: {
      'Content-Type': 'application/json',
      key: credentials.key,
      secret: credentials.secret,
    },
    method: (data.type ? data.type : 'GET'),
  };
  if (data.body) {
    settings.body = JSON.stringify(data.body);
  }

  (async () => {
    const res = await fetch(`${apiHost.host}${data.url}`, settings);
    const result = await res.text();

    try {
      data.callback(JSON.parse(result));
    } catch (e) {
      data.callback(result);
    }
  })();
};

const rqAsync = async (data: { body: ?Object, url: string, type: string }) => {
  const apiHost = hosts[process.env.NODE_ENV || 'development'];
  const settings = {
    headers: {
      'Content-Type': 'application/json',
      key: credentials.key,
      secret: credentials.secret,
    },
    method: (data.type ? data.type : 'GET'),
    body: data.body ? JSON.stringify(data.body) : null,
  };

  const res = await fetch(`${apiHost.host}${data.url}`, settings);
  const parsed = await res.json();

  return parsed;
};

const saveUser = (id: string, data: Object, callback: Function) => {
  if (credentials.access === 'user') {
    request({
      type: 'PUT',
      url: `/${credentials.access}/settings`,
      body: data.settings,
      callback,
    });
    request({
      type: 'PUT',
      url: `/${credentials.access}/rss`,
      body: data.modules.news.rssFeeds,
      callback,
    });
    request({
      type: 'PUT',
      url: `/${credentials.access}/contacts`,
      body: data.modules.calling.contacts,
      callback,
    });
    request({
      type: 'PUT',
      url: `/${credentials.access}/radio`,
      body: data.modules.radio.list,
      callback,
    });
  } else {
    request({
      type: 'PUT',
      url: `/${credentials.access}/users/${id}`,
      body: data,
      callback,
    });
  }
};

const inviteAdmin = (data: Object, callback: Function) => {
  request({
    type: 'POST',
    url: `/${credentials.access}/admins`,
    body: data,
    callback,
  });
};

const saveAdmin = (id: string, data: Object, callback: Function) => {
  request({
    type: 'PUT',
    url: `/${credentials.access}/admins/${id}`,
    body: data,
    callback,
  });
};

const getUser = (id: string, callback: Function) => {
  if (credentials.access === 'user') {
    request({ type: 'GET', url: `/${credentials.access}/profile`, callback });
  } else {
    request({ type: 'GET', url: `/${credentials.access}/users/${id}`, callback });
  }
};

export default {
  login,
  logout,
  getCurrentUser,
  isLoggedIn,

  users: {
    getListAsync: () => rqAsync({ type: 'GET', url: `/${credentials.access}/users/list` }),
    getList: (callback: Function) => { request({ type: 'GET', url: `/${credentials.access}/users/list`, callback }); },
    search: (filter: string, callback: Function) => { request({ type: 'GET', url: `/${credentials.access}/users/list?any=${filter}`, callback }); },
    get: getUser,
    save: saveUser,
    delete: (id: string, callback: Function) => { request({ type: 'DELETE', url: `/${credentials.access}/users/${id}`, callback }); },
  },

  telemetry: {
    medication: ({
      page = 1,
      startDate,
      endDate,
      ownerId,
    }: {
      page: number,
      startDate: ?string,
      endDate: ?string,
      ownerId: ?string,
    }, callback: Function) => {
      const query = queryString.stringify({ page, startDate, endDate, ownerId });

      request({
        type: 'GET',
        url: `/${credentials.access}/telemetry/list?eventName=medication.*&${query}`,
        callback });
    },
  },

  admins: {
    getList: (callback: Function) => { request({ type: 'GET', url: `/${credentials.access}/admins/list`, callback }); },
    search: (filter: string, callback: Function) => { request({ type: 'GET', url: `/${credentials.access}/admins/list?email=${filter}`, callback }); },
    invite: inviteAdmin,
    update: inviteAdmin,
    save: saveAdmin,
    delete: (id: string, callback: Function) => { request({ type: 'DELETE', url: `/${credentials.access}/admins/${id}`, callback }); },
  },

};



// WEBPACK FOOTER //
// ./src/services/api.js